$(document).ready(function() {
    $('.marquee').marquee({
      //duration in milliseconds of the marquee
      duration: 13000,
      //true or false - should the marquee be duplicated to show an effect of continues flow
      duplicated: true
    });
  
    const modal1 = document.getElementById('shipping-nav-modal');
    const openModalBtnMobile = document.getElementById('shipping_mobile_open');
    const openModalBtn1 = document.getElementById('shipping_nav_pop_out');
    const closeModalBtn1 = document.getElementById('close_shipping');
    // const openModalMarquee = document.getElementById('shipping_marquee_pop_out');

    const openModalMarquee = document.querySelectorAll('.shipping_marquee_pop_out');

    openModalMarquee.forEach(marqueeText => {
      marqueeText.addEventListener('click', function handleClick(event) {
        modal1.style.display = 'block';
        document.body.style.overflow = 'hidden';
      });
    });

    // Open the modal mobile
    openModalBtnMobile.addEventListener('click', () => {
        modal1.style.display = 'block';
        document.body.style.overflow = 'hidden';
    });
    
    // Open the modal
    openModalBtn1.addEventListener('click', () => {
        modal1.style.display = 'block';
        document.body.style.overflow = 'hidden';
    });
    
    // Close the modal
    closeModalBtn1.addEventListener('click', () => {
        modal1.style.display = 'none';
        document.body.style.overflow = 'unset';
    });
  
  var AnnouncementSwiper = new Swiper(".announcement-swiper", {
    slidesPerView: 1,
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
  });

  $('.close-btn').on('click',function() {
      $('.redirect-popup').removeClass('flex');
  })
  
  // var links = document.links;
  //   for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  //     if (links[i].hostname !== window.location.hostname) {
  //       links[i].target = '_blank';
  //       links[i].rel = 'noreferrer noopener';
  //     }
  //   }
  // this.$parents.each(((e,n)=>{Ns()(n,(function(e){t()("."+r.activeClass).each((function(n){var i=t()(this);0===i.has(e.target).length&&i.removeClass(r.activeClass);}))}),(function(){})),!t()(n).hasClass("mega-menu")&&t()(n).parent().hasClass("site-nav")&&t()(n).on("mouseleave",(()=>{r.hideDropdown()}))})),
  $('div.site-header__wrapper ul.site-nav li.main-nav-li').on("click touchstart focusin",function(){
      $('#dark-overlay-onhover').css('visibility', 'visible');
  });


  
$('.main_mobile_nav_parent').click(function() {
  $(this).parent().find('.new_mobile_sublist_slide_out').toggleClass('active');
  // $('ul#parent_menu_mobile').css('visibility', 'hidden');
   $('ul#parent_menu_mobile').toggleClass('slide_to_right');
  
});
  
$('.mobile_parent_sub_div').click(function() {
  // setTimeout(() => {
  //    $('ul#parent_menu_mobile').css('visibility', 'visible');
  // }, "100");
    $('ul#parent_menu_mobile').toggleClass('slide_to_right');
  
  $(this).parent().toggleClass('active');
});


  

  $(document).on('click', function(){
	$('#dark-overlay-onhover').css('visibility', 'hidden');
    $('div.site-header__wrapper ul.site-nav li.main-nav-li').removeClass('nav-hover');
  });

  
  // $('div.site-header__nav ul.site-nav li.site-nav--has-dropdown').on('mouseleave focusout',function(){
  //   if($(this).children('.site-nav__dropdown').is(":hidden")) {
  //     console.log('false');
  //   }
  //   $('#dark-overlay-onhover').css('visibility', 'hidden');
  // });
  

  // $(".swatch div.swatch-element").on( "click", function() {
  //   let checked_variant_color = $("input[name='option-1']:checked").val().toLowerCase().replace(/\s+/g, '-');
  //   var checked_variant_size = false;
  //   if($('body').attr('id').includes('desk-mat') || $('body').attr('id').includes('nest') ) {
  //     var checked_variant_size = $("input[name='option-2']:checked").val().toLowerCase().replace(/\s+/g, '-');
  //   }
    
  //   if(checked_variant_size){ 
  //     var selected_variant = checked_variant_color+'-'+checked_variant_size;
  //   } else {
  //     var selected_variant = checked_variant_color;
  //   }
    
  //   $('.color-switch-header').html($("input[name='option-1']:checked").val());
    
  //   $('[thumbnail-color]').hide();
  //   var selected_attribute = '[thumbnail-color="' + selected_variant + '"]';
  //   if (selected_variant == selected_variant) {
  //       $(selected_attribute).show();
  //     } 
  // });

  $("body").on("click","#CollectionProductGrid .swatch-collections div.swatch-element.color input:radio", function() {
    // let checked_variant_color = $(this).find("input[name='option-1']:checked").val().toLowerCase().replace(/\s+/g, '-');
    let checked_variant_color = $("input[name='option-1']:checked").val().toLowerCase().replace(/\s+/g, '-');
    
    let for_product = $("input[name='option-1']:checked").attr("for-product-swatch");
    // console.log($(this));
    var selected_variant = for_product+checked_variant_color;
    $('['+for_product+'-thumbnail-color]').hide();
    var selected_attribute = '['+for_product+'-thumbnail-color="' + selected_variant + '"]';

    if (selected_variant == selected_variant) {
        $(selected_attribute).show();
      }
    
    // console.log($(e.target).attr("data-product-id"));
    // console.log($(this).find('.swatch-label'));
  });

  
   $('div#accordion_tab').find('.accordion-toggle').click(function(){
      //Expand or collapse this panel
     
     if($(this).find('span').text() == '+') {
        $(this).find('span').text('-');
      } else {
       console.log($(this).find('span').text());
         $(this).find('span').text('+');
      }
     
      $(this).next().slideToggle('fast');
      if($(this).find('span').hasClass('open')){
          // $(this).find('span').text('+');        
          $(this).find('span').removeClass('open');
      }else{
          $('.accordion-toggle span').removeClass('open');
          // $('.accordion-toggle span').text('+');
          // $(this).find('span').text('-');
          $(this).find('span').addClass('open');
      }    
      //Hide the other panels
      $(".accordion-content").not($(this).next()).slideUp('fast');    
    });


//   function showVariantGallery(selected, selector) {
//     var mediaJson = $('.media_slider').data('media-json');
//     var mediaLength = $('.media_slider').data('media-length');
//     var galleryJson = $('.single-image_slider').data('gallery-json');
//     var galleryLength = $('.single-image_slider').data('gallery-length');

// //     console.log(galleryJson);

// //     console.log(selected);
// //     console.log(selector);



// 	// If product has multiple swatches
//     let multiSwatches = [];
//     if($('.swatch').length > 1) {
// 		$('.swatch').each(function() {
// 			const _this = $(this);
//           	let swatches = _this.find('input:checked').val();
//             console.log('swatch name:' + swatches);
//       		swatches = swatches.toLowerCase().replace(/\s+/g, '-');
//       		multiSwatches.push(swatches);
// 		})
//     }

//     let selectedVariant = '';
//     // let y = 0;
//     let z = 0;
//     if(!selector) {
//         selectedVariant = selected;
//     } else {
//         selectedVariant = selected.data('value');
//     }
//     selectedVariant = selectedVariant.toLowerCase().replace(/\s+/g, '-');


// //     console.log(mediaJson);
//     if($('.single-image_slider').hasClass('slick-initialized')) {
//         $('.single-image_slider').slick('unslick');
//     }

//     $('.single-image_slider img').remove();
// 	$('.single-image_slider .yt-iframe,.single-image_slider .media-video').remove();
//     $('.thumbnail-nav img').remove();

//     // for(let i = 0; i < galleryLength; i++) {
//     //     let currentImage = galleryJson[i];
//     //     if(currentImage.indexOf(selectedVariant) !== -1) {
//     //         $(`<img src="${currentImage}" loading=lazy>`).appendTo('.single-image_slider');
//     //         $(`<img src="${currentImage}" data-thumbnail-id="${y}">`).appendTo('.thumbnail-nav');

//     //         y++;
//     //     }
//     // }

//     for(let i = 0; i < mediaLength; i++) {
//         let currentMedia = mediaJson[i + 1];

//         // console.log(currentMedia);
//         // console.log(selectedVariant);
//         // console.log(currentMedia.media_type);
//         if(currentMedia.media_type === 'image') {
//           if(multiSwatches.length < 2) {
//             if(currentMedia.src.indexOf(selectedVariant) !== -1) {
//                 $(`<img class="product_image" src="${currentMedia.src.includes('.jpg') ? currentMedia.src.replace('.jpg', '_1000x1000.jpg') : currentMedia.src.replace('.png', '_1000x1000.png')}" loading=lazy>`).appendTo('.single-image_slider');
//               $(`<img src="${currentMedia.src.includes('.jpg') ? currentMedia.src.replace('.jpg', '_200x200.jpg') : currentMedia.src.replace('.png', '_200x200.png')}" data-thumbnail-id="${z}">`).appendTo('.thumbnail-nav');
//                 z++;
//             }

//           } else {
// 			// n = multiSwatches.length
// 			// Loop through the swatches in the array and if they match the currentMedia.src n amount of times then it will get outputted
//             const multiSwatchesLength = multiSwatches.length;
//             let swatchMatches = 0;

//             multiSwatches.forEach(function(swatch) {
//               if(currentMedia.src.indexOf(swatch) !== -1) {
//                 swatchMatches++;
//               }
//             })

//             if(multiSwatchesLength === swatchMatches) {
//              	$(`<img class="product_image" src="${currentMedia.src.includes('.jpg') ? currentMedia.src.replace('.jpg', '_1000x1000.jpg') : currentMedia.src.replace('.png', '_1000x1000.png')}" loading=lazy>`).appendTo('.single-image_slider');
//                 $(`<img class="product-medias__thumbnail" src="${currentMedia.src.includes('.jpg') ? currentMedia.src.replace('.jpg', '_200x200.jpg') : currentMedia.src.replace('.png', '_200x200.png')}" data-thumbnail-id="${z}">`).appendTo('.thumbnail-nav');
//                 z++;
//             }
// //             if(currentMedia.src.indexOf(multiSwatches[0]) !== -1 && currentMedia.src.indexOf(multiSwatches[1]) !== -1) {

// //             }
//           }

//         } else if (currentMedia.media_type === 'model') {
// //             if(currentMedia.preview_image.src.indexOf(selectedVariant) !== -1) {
// //                 $(`<div class="3d-model"><model-viewer class="slider_model" style="width: 100%;" src="${currentMedia.sources[0].url}" alt="A 3D model" auto-rotate camera-controls></model-viewer></div>`).appendTo('.single-image_slider');
// //                 $(`<img src="${currentMedia.preview_image.src}" data-thumbnail-id="${z}">`).appendTo('.thumbnail-nav');
// //                 z++;
// //             }

//         } else if (currentMedia.media_type === 'external_video') {
//             if(currentMedia.alt.indexOf(selectedVariant) !== -1) {
// //               console.log(currentMedia.alt + " VS " + selectedVariant);
//                 // $(`<div class="yt-iframe"><div class="video_preview" style="background-image:url(${currentMedia.preview_image.src})"><div class="play-btn"></div></div><iframe class="slider_video hide" width="100%" src="https://www.youtube.com/embed/${currentMedia.external_id}?controls=0" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>`).appendTo('.single-image_slider');
//                 $(`<div class="yt-iframe"><iframe class="slider_video" width="100%" src="https://www.youtube.com/embed/${currentMedia.external_id}?controls=0" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>`).appendTo('.single-image_slider');
//                 $(`<img class="product-medias__thumbnail" src="${currentMedia.preview_image.src}" data-thumbnail-id="${z}">`).appendTo('.thumbnail-nav');
//                 z++;
//             }

//         } else if (currentMedia.media_type === 'video') {
//             if(currentMedia.alt.indexOf(selectedVariant) !== -1) {
//                 // $(`<div class="yt-iframe"><div class="video_preview" style="background-image:url(${currentMedia.preview_image.src})"><div class="play-btn"></div></div><iframe class="slider_video hide" width="100%" src="https://www.youtube.com/embed/${currentMedia.external_id}?controls=0" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>`).appendTo('.single-image_slider');
//                 $(`<div class="media-video"><video width="100%" height="100%" controls playsinline loop><source src="${currentMedia.sources[0].url}" type="video/mp4"></video></div>`).appendTo('.single-image_slider');
//                 $(`<img class="product-medias__thumbnail" src="${currentMedia.preview_image.src}" data-thumbnail-id="${z}">`).appendTo('.thumbnail-nav');
//                 z++;
//             }

//         }


//     }
//   if(window.innerWidth <= 768) {
// 		$('.product-video__wrapper').appendTo('.single-image_slider');
//     }



//     $('.single-image_slider').slick({
//         arrows: false,
//         prevArrow:"<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
//         nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
//         infinite: true,
//         speed: 300,
//         slidesToShow: 1,
//         lazyLoad: 'ondemand',
//         // adaptiveHeight: true,
//         responsive: [
//             {
//               breakpoint: 769,
//               settings: {
//                 arrows: true,
//                 dots: true
//               }
//             }
//         ]
//     })
    
//     const slickLength = $('.slick-dots li').length;

//     $('.single-image_slider').on('afterChange', function() {
//       if($('.slick-active video').length) {
//       	const vid = document.querySelector(".slick-active video");        
// //         vid.currentTime = 0;
// //       	console.log(vid);
// 	  	vid.play();
//       }
//     });

//     $('.thumbnail-nav img').click(function() {
//         if(document.querySelector(".product-video__wrapper video")) {
//             document.querySelector(".product-video__wrapper video").pause();
//         }
//         $('.product-video__wrapper').css('z-index', -1);
//         var slideIndex = $(this).data('thumbnail-id');
//         // console.log(slideIndex);
//         $('.single-image_slider').slick('slickGoTo', slideIndex);
//     })

// }

// // selectedVariant = gup('variant');
// var vid = document.querySelector(".product-video__wrapper video");
// let selectedVariant = '';


// $('.swatch-form-hidden option').each(function() {
//     // console.log($(this))
//     if($(this).is(':selected')) {
//         // console.log($(this).text())
//         selectedVariant = $(this).text();
//         selectedVariant = selectedVariant.toLowerCase().replace(/\s+/g, '-');
//     }
// })

// showVariantGallery(selectedVariant, false);

// $('.swatch div').click(function() {
//     showVariantGallery($(this), true);
// })


// $('.swatch .swatch-element').click(function() {
//     if(vid) {
//         vid.pause();
//     }
  
//     $('.product-video__wrapper').css('z-index', -1);

// })

// $('.product-video-button').click(function() {
//     if(vid) {
//         vid.play();
//     }
//     $('.product-video__wrapper').css('z-index', 5).css('display', 'block');
// })

// // Update iframe / model-viewer height
// $(window).resize(function() {
//     var productHeight = $('.product_image').height();
//     $('.slider_video, .slider_model, .video_preview').css('height', productHeight);
// })
  
});